const WORDS = { et: 1, en: 1, "ét": 1, "én": 1, to: 2, tre: 3, fire: 4, fem: 5, seks: 6, syv: 7, otte: 8, ni: 9, ti: 10, elleve: 11, tolv: 12, femten: 15, tyve: 20, tredive: 30, fyrre: 40, halvanden: 1.5 };
const NUM = String.raw`\d+(?:[.,]\d+)?(?:\s*½|\s+1\/2)?|½|1\/2|halvanden|et|en|ét|én|to|tre|fire|fem|seks|syv|otte|ni|ti|elleve|tolv|femten|tyve|tredive|fyrre`;
const UNIT = String.raw`minutter|minut|min\.?|timer|time|sekunder|sekund|sek\.?|kvarter`;
const RE = new RegExp(String.raw`(?<![\p{L}\d])(${NUM})(?:\s*(?:-|–|til)\s*(${NUM}))?\s*(halvt?\s+)?(${UNIT})(?![\p{L}])`, "giu");
const SEC = u => (u.startsWith("kvarter") ? 900 : u.startsWith("tim") ? 3600 : u.startsWith("sek") ? 1 : 60);

const val = s => {
  s = s.toLowerCase().trim();
  if (s in WORDS) return WORDS[s];
  const half = /½|1\/2$/.test(s) && !/^1\/2$/.test(s) ? 0.5 : 0;
  if (s === "½" || s === "1/2") return 0.5;
  return parseFloat(s.replace(/\s*(½|1\/2)$/, "").replace(",", ".")) + half;
};

// Danish durations in a step text -> [{ secs, text }]; ranges use the upper value
export function durations(text) {
  const out = [];
  for (const m of text.matchAll(RE)) {
    if (/inden for\s*$/i.test(text.slice(0, m.index))) continue;
    const n = val(m[2] || m[1]) * (m[3] ? 0.5 : 1);
    const secs = Math.round(n * SEC(m[4].toLowerCase()));
    if (!(secs > 0)) continue;
    const prev = out[out.length - 1];
    if (prev && prev.secs % 3600 === 0 && SEC(m[4]) === 60 && /^\s+og\s+$/.test(text.slice(prev.end, m.index))) {
      prev.secs += secs; prev.text += text.slice(prev.end, m.index) + m[0]; prev.end = m.index + m[0].length; continue;
    }
    out.push({ secs, text: m[0], end: m.index + m[0].length });
  }
  const seen = new Set();
  return out.filter(d => !seen.has(d.secs) && seen.add(d.secs)).map(({ secs, text }) => ({ secs, text }));
}

export const timerLabel = secs => (secs < 60 ? `${secs} sek` : `${Math.round(secs / 6) / 10}`.replace(".", ",") + " min");

export const mmss = ms => {
  const s = Math.max(0, Math.ceil(ms / 1000));
  return `${String(Math.floor(s / 60)).padStart(2, "0")}:${String(s % 60).padStart(2, "0")}`;
};
